import './table-loader.scss';

const TableLoader = () => {
    return (
        <div className='table-loader'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default TableLoader;